import {createSelector} from 'reselect';
import {getLoggedUser} from './store';

const getUserData = createSelector(
    [getLoggedUser],
    (loggedUser) => {
        return loggedUser.userData ? loggedUser.userData : null;
    }
);

export default getUserData;
export {getUserData};